<section class="select-currency-container">
  <div class="row">
    @for (currency of currencies(); track currency._id) {
      <div class="col-6 col-md-4 col-lg-3 col-xl-3">
        <button
          class="card default-button text-start"
          [class.active-card]="selectedCurrencyCode() === currency.currency"
          (click)="
            selectCurrency({
              currency: currency.currency,
              currency_name: currency.currency_name,
            }).subscribe()
          "
          (keydown.enter)="
            selectCurrency({
              currency: currency.currency,
              currency_name: currency.currency_name,
            }).subscribe()
          "
          tabindex="0"
        >
          <div class="card-header">
            <p
              class="card-header-title"
              [class.primary-font-bold]="theme() === GbTheme.ThemeOne"
              [class.primary-font-semibold]="theme() === GbTheme.ThemeTwo"
            >
              {{ currency.currency_name }}
            </p>
            @if (theme() === GbTheme.ThemeOne) {
              <div class="radio-button-container">
                <input
                  type="radio"
                  name="currency"
                  [checked]="selectedCurrencyCode() === currency.currency"
                  [id]="'currency-' + currency.currency"
                />
                <span class="checkmark"></span>
              </div>
            }
          </div>
          <p class="primary-font-regular card-description">
            {{ currency.currency }} - {{ currencySymbolPipe.transform(currency.currency) }}
          </p>
        </button>
      </div>
    }
  </div>
</section>
